<div>
  <h3>dashboard works!</h3>

  <!-- <iframe #iframe src="/assets/FlowDesigner/LogicApps.html" style="width:100%; height: 600px;"></iframe>

  <button (click)="loadFlow()">Load Designer</button> -->


  

</div>
